module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX"
  }, [_c('router-view'), _vm._v(" "), (_vm.modus != 'top' && _vm.modus != 'flop') ? _c('searchfield', {
    attrs: {
      "count": _vm.subcategories.length
    }
  }) : _vm._e(), _vm._v(" "), _c('back', {
    attrs: {
      "link": _vm.link
    }
  }), _vm._v(" "), _c('settings'), _vm._v(" "), _c('div', {
    staticClass: "names",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.$parent.names.hatg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Artikelgruppen")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showUE == 1) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.mode = '1'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.mode = '2'
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Erlös\r\n                        ")])]) : _vm._e()]), _vm._v(" "), (_vm.modus != '') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [(_vm.mode == '1') ? _c('div', {
    staticClass: "chart",
    attrs: {
      "id": "atgCustomerChart1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == '2') ? _c('div', {
    staticClass: "chart",
    attrs: {
      "id": "atgCustomerChart2"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('years', {
    attrs: {
      "years": _vm.years[1],
      "period": _vm.period
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.mode == '1') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.subcategories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.umsatzDiff) + "%)\r\n                                    ")]), _vm._v("\r\n                    \r\n                    " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.subcategories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(_vm.sum)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : (category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                   \r\n                                    (" + _vm._s(category.umsatzDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mode == '2') ? _c('span', [(_vm.modus != '') ? _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', [_vm._l((_vm.subcategories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(" " + _vm._s(category.name) + "\r\n                ")]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                     \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                        \r\n                                        (" + _vm._s(category.erloesDiff) + "%)\r\n                                    ")]), _vm._v("\r\n                    \r\n                    " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                    "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.subcategories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                        Andere\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                        " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                    ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.modus != '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : (category.erloesLj > category.erloeszVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsmcyha',
          params: {
            year: _vm.$route.params.year,
            hatg: _vm.$route.params.hatg,
            atg: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.erloesNearlyEqual) ? _c('span', {
      staticClass: "stagnation"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : (category.erloesLj > category.erloesVj) ? _c('span', {
      staticClass: "upward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]) : _c('span', {
      staticClass: "downward"
    }, [_vm._v("\r\n                                    \r\n                                    (" + _vm._s(category.erloesDiff) + "%)\r\n                                ")]), _vm._v(" " + _vm._s(_vm._f("myCurrency")(category.erloesLj)) + " €\r\n                                "), _c('br'), _vm._v(" "), (category.erloesVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.erloesVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb3f9e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/Dashboard/MaincategoryHatg.html
// module id = 558
// module chunks = 1